import { render, staticRenderFns } from "./trialApplication.vue?vue&type=template&id=90f35aa2&scoped=true"
import script from "./trialApplication.vue?vue&type=script&lang=js"
export * from "./trialApplication.vue?vue&type=script&lang=js"
import style0 from "./trialApplication.vue?vue&type=style&index=0&id=90f35aa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f35aa2",
  null
  
)

export default component.exports